<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <page-header>
      {{ $t('reservationTableManage') }}
      <template #action>
        <div class="d-flex align-center">
          <v-spacer />

          <v-btn
            :icon="!$vuetify.breakpoint.mdAndUp"
            class="warning lighten-4 black--text"
            outlined
            @click="closeAllTable"
          >
            <v-icon
              :center="!$vuetify.breakpoint.mdAndUp"
              :left="$vuetify.breakpoint.mdAndUp"
            >
              mdi-lock-outline
            </v-icon>
            <template v-if="$vuetify.breakpoint.mdAndUp">
              {{ $t('closeAll') }}
            </template>
          </v-btn>
          <v-btn
            :icon="!$vuetify.breakpoint.mdAndUp"
            class="amber lighten-4 black--text ml-2"
            outlined
            @click="openAllTable"
          >
            <v-icon
              :center="!$vuetify.breakpoint.mdAndUp"
              :left="$vuetify.breakpoint.mdAndUp"
            >
              mdi-lock-open-variant-outline
            </v-icon>
            <template v-if="$vuetify.breakpoint.mdAndUp">
              {{ $t('openAll') }}
            </template>
          </v-btn>
        </div>
      </template>
    </page-header>
    <loading-provider :loading="loading">
      <div
        class="mt-4"
        style="display: grid;grid-gap: 8px;grid-template-columns: repeat(auto-fill,minmax(96px,1fr));width: 100%"
      >
        <v-card
          v-for="(t) in tableList"
          :key="t.id"
          :color="t.active?'amber lighten-4 black--text':'#eeeeee'"
          :dark="t.active"
          class="pa-4"
          elevation="0"
          @click="changeReserveStatus(t)"
        >
          <v-responsive
            :aspect-ratio="1"
          >
            <div
              class="d-flex align-center justify-center flex-column"
              style="height: 100%"
            >
              <div class="text-h3 font-weight-black">
                {{ t.name }}
              </div>
              <div class="mt-2 d-flex align-center font-weight-regular text-caption">
                <div>{{ $t('tableForPeople', [t.seatCount ? t.seatCount : 0]) }}</div>
              </div>
            </div>
          </v-responsive>
        </v-card>
      </div>
    </loading-provider>
    <loading-dialog :just-wait="justWait" />
  </div>
</template>

<script>
import LoadingDialog from '@/views/widget/LoadingDialog.vue'
import { showSuccessMessage } from '@/model/utils/utils'
import { today } from '@/model/utils/DateRepository'
import PageHeader from '@/views/widget/typography/PageHeader'
import LoadingProvider from '@/views/widget/LoadingProvider'
import {
  addTableReserve,
  getReserveTable,
  removeTableReserve
} from '@/model/dataLayer/service/reservation/reservation'

export default {
  name: 'UsefulReserveTable',
  components: {
    LoadingProvider,
    LoadingDialog,
    PageHeader
  },
  data: () => {
    return ({
      loading: false,
      isLoading: null,
      sureToAdd: false,
      tableSeat: null,
      removeChair: null,
      isShowUsefulTable: false,
      justWait: false,
      tableList: [],
      needTable: null,
      showUsefulTable: null,
      today,
      startTime: null,
      reservationDate: today,
      menu: false,
      openTime: null,
      datepicker: false,
      timeGap: null,
      adultCount: 1,
      childCount: 0
    })
  },
  mounted () {
    this.reloadData()
  },
  methods: {
    async openAllTable () {
      this.justWait = true
      const res = this.tableList.filter(it => !it.active)
      for (const item of res) {
        await addTableReserve(item.id)
      }
      this.justWait = false
      await this.reloadData()
      showSuccessMessage(this.$t('setTableSuccess'))
    },
    async closeAllTable () {
      this.justWait = true
      const res = this.tableList.filter(it => it.active)
      for (const item of res) {
        await removeTableReserve(item.id)
      }
      this.justWait = false
      await this.reloadData()
      showSuccessMessage(this.$t('clearTableSuccess'))
    },
    async changeReserveStatus (item) {
      if (!item.active) {
        this.justWait = true
        await addTableReserve(item.id)
        this.justWait = false
        await this.reloadData()
        showSuccessMessage(this.$t('setTableSuccess'))
      } else {
        this.justWait = true
        await removeTableReserve(item.id)
        this.justWait = false
        await this.reloadData()
        showSuccessMessage(this.$t('clearTableSuccess'))
      }
      await this.reloadData()
    },
    async reloadData () {
      this.loading = true
      this.tableList = (await getReserveTable())
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
